import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import Anchor from '@atlaskit/primitives/anchor';
var textStyles = xcss({
  color: 'color.text.subtle'
});
var anchorStyles = xcss({
  textDecoration: 'none',
  ':hover': {
    color: 'color.link',
    textDecoration: 'underline'
  },
  ':active': {
    color: 'color.link.pressed',
    textDecoration: 'none'
  }
});
var noAuthorStyles = xcss({
  fontWeight: 'inherit'
});
var hasAuthorStyles = xcss({
  fontWeight: "var(--ds-font-weight-medium, 500)"
});

/**
 * __Field__
 *
 * A field appears in the comment header to add metadata to the comment.
 *
 * @internal
 */
var Field = function Field(_ref) {
  var children = _ref.children,
    hasAuthor = _ref.hasAuthor,
    href = _ref.href,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onMouseOver = _ref.onMouseOver,
    testId = _ref.testId;
  return href ? /*#__PURE__*/React.createElement(Anchor, {
    href: href,
    xcss: [textStyles, anchorStyles, hasAuthor ? hasAuthorStyles : noAuthorStyles],
    onClick: onClick,
    onFocus: onFocus,
    onMouseOver: onMouseOver,
    testId: testId
  }, children) : /*#__PURE__*/React.createElement(Box, {
    as: "span",
    xcss: [textStyles, hasAuthor ? hasAuthorStyles : noAuthorStyles]
    /**
     * It is not normally acceptable to add key handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * to add support for analytics instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there are no negative
     * impacts to assistive technologies.
     */,
    role: "presentation",
    onClick: onClick,
    onFocus: onFocus,
    onMouseOver: onMouseOver,
    testId: testId
  }, children);
};
export default Field;